import { defineComponent as R, computed as l, useSlots as D, createElementBlock as s, openBlock as o, normalizeClass as d, createElementVNode as v, createBlock as m, createCommentVNode as n, toDisplayString as r, resolveDynamicComponent as T, withCtx as f, createTextVNode as g, renderSlot as S, createVNode as I, unref as b, mergeProps as A } from "vue";
import { RevButton as h } from "@ds/components/Button";
import { RevIllustration as $ } from "@ds/components/Illustration";
import { isString as j } from "../../utils/isString.js";
import { isValidNumber as y } from "../../utils/isValidNumber.js";
import { tw as e } from "../../utils/tailwind.js";
const E = {
  key: 0,
  class: "text-static-default-low body-2 mb-2"
}, z = {
  key: 1,
  class: "text-static-default-low body-1"
}, W = {
  key: 2,
  class: "mt-20 hidden md:block"
}, M = /* @__PURE__ */ R({
  name: "RevContentBlock",
  __name: "ContentBlock",
  props: {
    hasRoundedContainer: { type: Boolean, default: !1 },
    buttonDisabled: { type: Boolean, default: !1 },
    buttonLabel: { default: () => {
    } },
    target: { default: "_self" },
    buttonLoading: { type: Boolean, default: !1 },
    hasRoundedImage: { type: Boolean, default: !1 },
    buttonLoadingAlternativeText: {},
    buttonVariant: { default: "primary" },
    imageLeft: { type: Boolean, default: !1 },
    imageProps: {},
    surtitle: {},
    title: {},
    titleTag: { default: "h2" },
    titleVariant: { default: "title1" },
    to: {}
  },
  emits: ["click"],
  setup(a) {
    const k = l(() => [
      e`flex flex-col md:flex-row md:items-center`,
      a.hasRoundedContainer && e`rounded-lg overflow-hidden`
    ]), C = l(() => [
      e`text-static-default-hi mb-8`,
      a.titleVariant === "punchline" && e`punchline`,
      a.titleVariant === "title1" && e`heading-1`,
      a.titleVariant === "title2" && e`heading-2`
    ]), w = l(() => [
      e`w-full`,
      a.hasRoundedImage && e`rounded-lg overflow-hidden`
    ]), L = l(() => [
      e`min-w-[40%] flex-initial items-center justify-center md:mb-0 md:w-448 md:min-w-448`,
      a.imageLeft ? e`mb-16` : e`order-1 md:ml-auto`
    ]), B = l(() => [
      e`flex flex-col justify-center md:mb-0`,
      a.imageLeft ? e`order-1 md:ml-56 md:mr-0` : e`mb-16 md:mr-56`
    ]), c = l(() => a.buttonLabel !== void 0), V = l(() => !!a.surtitle), p = D(), N = l(() => !!p), P = l(
      () => j(a.imageProps.src) && y(a.imageProps.height) && y(a.imageProps.width)
    );
    return (t, i) => (o(), s("div", {
      class: d(k.value)
    }, [
      v("div", {
        class: d(B.value)
      }, [
        V.value ? (o(), s("p", E, r(t.surtitle), 1)) : n("", !0),
        (o(), m(T(t.titleTag), {
          class: d(C.value)
        }, {
          default: f(() => [
            g(r(t.title), 1)
          ]),
          _: 1
        }, 8, ["class"])),
        N.value ? (o(), s("div", z, [
          S(t.$slots, "default")
        ])) : n("", !0),
        c.value ? (o(), s("div", W, [
          I(b(h), {
            disabled: t.buttonDisabled,
            loading: t.buttonLoading,
            "loading-alternative-text": t.buttonLoadingAlternativeText,
            target: t.target,
            to: t.to,
            variant: t.buttonVariant,
            onClick: i[0] || (i[0] = (u) => t.$emit("click", u))
          }, {
            default: f(() => [
              g(r(t.buttonLabel), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading", "loading-alternative-text", "target", "to", "variant"])
        ])) : n("", !0)
      ], 2),
      v("div", {
        class: d(L.value)
      }, [
        P.value ? (o(), m(b($), A({ key: 0 }, t.imageProps, {
          alt: t.imageProps.alt || "",
          class: w.value
        }), null, 16, ["alt", "class"])) : n("", !0)
      ], 2),
      c.value ? (o(), m(b(h), {
        key: 0,
        class: "order-2 mt-20 md:!hidden",
        "data-test": "small-screen-button",
        disabled: t.buttonDisabled,
        "full-width": "always",
        loading: t.buttonLoading,
        "loading-alternative-text": t.buttonLoadingAlternativeText,
        target: t.target,
        to: t.to,
        variant: t.buttonVariant,
        onClick: i[1] || (i[1] = (u) => t.$emit("click", u))
      }, {
        default: f(() => [
          g(r(t.buttonLabel), 1)
        ]),
        _: 1
      }, 8, ["disabled", "loading", "loading-alternative-text", "target", "to", "variant"])) : n("", !0)
    ], 2));
  }
});
export {
  M as default
};
